import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { SyntheticEvent, useState } from 'react'

import { ExternalWrapper } from './components/ExternalWrapper'
import { Memo } from './components/Memo'

export const MemoStenographySharePage = () => {
    const [value, setValue] = useState(0)

    const handleChange = (event: SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }

    return (
        <ExternalWrapper>
            <Grid size={12}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    sx={{ borderBottom: 'none', padding: 0 }}>
                    <Tab label="Саммари" id="1" />
                </Tabs>
                <Divider sx={{ width: '100%', my: 3, height: ' 1px' }} />
            </Grid>
            <Memo />
        </ExternalWrapper>
    )
}
